import React from 'react'
import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import { closeNotification } from './actions/index'
import store from './store/index'
import { IState } from './reducers'
import { useTheme } from '@mui/material/styles'

const PREFIX = 'NotificationBar'

const classes = {
  close: `${PREFIX}-close`,
}

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  [`&.${classes.close}`]: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
}))

const mapStateToProps = (state: IState) => {
  return {
    showNotification: state.showNotification,
    newNotificationMessage: state.newNotificationMessage,
    notificationSeverity: state.notificationSeverity,
  }
}

const SimpleSnackbar = (props: any) => {
  const { showNotification, newNotificationMessage, notificationSeverity } = props
  const theme = useTheme()

  const handleClose = () => {
    store.dispatch(closeNotification(false))
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={showNotification}
      autoHideDuration={6000}
      onClose={handleClose}
    >
      <Alert
        onClose={handleClose}
        severity={notificationSeverity}
        sx={{
          width: '100%',
          ...(theme.palette.mode === 'dark' && {
            backgroundColor: 'rgba(23, 23, 23, 0.95)',
            backdropFilter: 'blur(20px)',
            border: '1px solid rgba(64, 64, 64, 0.3)',
          })
        }}
      >
        {newNotificationMessage}
      </Alert>
    </Snackbar>
  )
}

const List = connect(mapStateToProps)(SimpleSnackbar)
export default List
